import React from 'react';
import PropTypes from 'prop-types';
import './Dashboard.scss';

const DashboardAttribute = (props) => {
  if (!props.children) {
    return null;
  }
  const multiLineClass = props.hasMultiLineValue ? ' multiline' : '';

  return (
    <div className="dashboard-attribute">
      <h4 className="dashboard-attribute-label">{props.label}</h4>
      <div id={props.valueId} className={`dashboard-attribute-value${multiLineClass}`}>
        {props.children}
      </div>
    </div>
  );
};

DashboardAttribute.propTypes = {
  label: PropTypes.string.isRequired,
  valueId: PropTypes.string,
  hasMultiLineValue: PropTypes.bool,
  children: PropTypes.node
};

export default DashboardAttribute;



/** WEBPACK FOOTER **
 ** ./src/components/myaccount/Dashboard/DashboardAttribute.js
 **/